module.exports = __webpack_public_path__ + "static/media/arpPacketFormat.4bbe011b.png";